import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { G2S } from 'core/g2s';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductPackageComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    product: flights.ProductModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    isProductSelected: boolean | null = null;

    alreadyInPackageModal = {
        message: '',
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        acceptCallback: () => { },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        refuseCallback: () => { }
    }

    mounted() {
        const stepNumber = this.product.product.stepNumber;
        const kitId = this.product.product?.kitId || '';
        const id = this.product.product.id;
        const label = `product.step${stepNumber}.kit${kitId}.id${id}`;

        if(!this.gaAlreadySubmitted.includes(label)) {
            (<any>this).$ga.sendEvent('product',
                'display',
                label,
                this.gaParams
            );
            this.gaAlreadySubmitted.push(`flights.booking.display.product.step${stepNumber}.kit${kitId}.id${id}`);
        }

        if (!this.product.needToSelect) {
            this.isProductSelected = this.product.selected;
        }
    }

    get relatedProducts() {
        return this.reservation.getPackageRelatedProductsByExternalId(this.product.product.externalId);
    }

    get yandexSuperSms() {
        // @Todo Удалить или отрефакторить yandex код
        return this.reservation.products.find(item => item.product.externalId == 'MegoPackageSuperSms' && item.product.saleType == 'YandexPayButton');
    }

    getProductIcon(product: flights.ProductModel): string {
        let urlPrefix = '/i/icons/lg/';

        if (G2S.config.theme === 'aviasales') {
            urlPrefix = '/themes/aviasales/i/icons/lg/';
        }

        return urlPrefix + (product.product.details.iconLarge ? product.product.details.iconLarge : 'empty') + '.svg';
    }

    onProductDetails(product: flights.ProductModel) {
        (<any>this).$ga.sendEvent('product',
            'detail',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );

        this.$emit('product-details', product);
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        this.product.needToSelect = false;
        this.product.selected = value;

        if (value && product) {
            product.choiceType = api.ProductChoiceType.manualAccepted;

            if (this.relatedProducts.length) {
                this.relatedProducts.forEach(relatedProduct => {
                    let productToUnselect: flights.ProductModel | undefined = undefined;

                    if (relatedProduct.criterion == 'equal') {
                        productToUnselect = this.reservation.products.find(product =>
                            product.product.externalId == relatedProduct.externalId
                        );
                    }

                    if (relatedProduct.criterion == 'popup') {
                        productToUnselect = this.reservation.products.find(product =>
                            utils.String.startsWith(product.product.externalId, relatedProduct.externalId)
                        );

                        if (productToUnselect && productToUnselect!.selected) {
                            this.alreadyInPackageModal.message = i18next.t('label_product_already_in_package', <any>{ i: productToUnselect!.product.name });
                            this.alreadyInPackageModal.acceptCallback = () => {
                                (<any>this.$refs).alreadyInPackageDialog.isActive = false;
                                productToUnselect!.selected = false;
                            };
                            this.alreadyInPackageModal.refuseCallback = () => {
                                (<any>this.$refs).alreadyInPackageDialog.isActive = false;
                            };
                            (<any>this.$refs).alreadyInPackageDialog.isActive = true;
                        }
                    }
                });
            }
        } else if (product) {
            product.choiceType = api.ProductChoiceType.confirmationDenied;
        }

        (<any>this).$ga.sendEvent('product',
            value ? 'btn.ok' : 'btn.cancel',
            `product.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
            this.gaParams
        );

        this.$emit('product-selection-change', product, value);
    }
}
